export const getFileExtensionByName = filename => {
  const ext = filename.split('.').pop();
  return ext === filename ? '' : ext;
};
